module.exports = __webpack_public_path__ + "img/spades.75acdd69.png";